import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'duration',
    pure: false
})
export class DurationFormatterPipe implements PipeTransform {

    transform(value: { startTimestamp: number, endTimestamp: number } | number): string {
        if (value) {
            if (isNaN(value as any)) {
                const end = (value as any).endTimestamp || moment().valueOf();
                return this.formatDuration(end, (value as any).startTimestamp);
            } else {
                return this.formatDurationMillis(value as number)
            }
        }
        return null;
    }

    private formatDuration(end, start): string {
        return this.formatDurationMillis(end - start);
    }

    private formatDurationMillis(millis: number): string {
        const d = moment.duration(millis);
        let result = '';
        if (d.asDays() >= 1) {
            result += ` ${parseInt(d.asDays() + '')}d`;
        }
        if (d.hours() > 0 || result !== '') {
            result += ` ${d.hours()}h`;
        }
        if (d.minutes() > 0 || result !== '') {
            result += ` ${d.minutes()}m`;
        }
        if (d.seconds() > 0 || result !== '') {
            result += ` ${d.seconds()}s`;
        }
        if (d.milliseconds() > 0 && result === '') {
            result += ` < 1s`;
        }
        return result.trim();
    }
}
